/** Short modules (few submodules) — top row. */
export const MODULE_ROW_TOP = ['registration', 'business', 'business-development']
/** Dense modules — bottom row. */
export const MODULE_ROW_BOTTOM = ['workplace', 'discovery', 'knowledge']
export const KNOWN_MODULE_KEYS = new Set([...MODULE_ROW_TOP, ...MODULE_ROW_BOTTOM])

export const MODULE_LABELS = {
  workplace: 'Dashboard',
  registration: 'Registration',
  discovery: 'Market Research',
  'business-development': 'Business Development',
  business: 'Marketing',
  knowledge: 'Bid Ready',
}

export const indexModulesByKey = (modules) => {
  if (!Array.isArray(modules)) return {}
  return modules.reduce((acc, module) => {
    if (module?.key) acc[module.key] = module
    return acc
  }, {})
}

export const pickModulesByKeys = (modulesByKey, keys) =>
  keys.map((key) => modulesByKey[key]).filter(Boolean)

export const getLeftoverModules = (modules) =>
  (modules || []).filter((module) => module?.key && !KNOWN_MODULE_KEYS.has(module.key))

export const getTabOptionsList = (subscriptionSettings, optionTab) => {
  const tabUsers = subscriptionSettings?.find((obj) => obj.idTab == optionTab)
  return tabUsers?.existingUsers?.optionsList || []
}

const withToggledSubmodules = (submodules, checked) =>
  submodules.map((opt) => ({
    ...opt,
    aCheckBox: checked,
    vCheckBox: checked,
    active: checked,
  }))

export const toggleModuleInOptions = (optionLists, moduleKey, checked) =>
  optionLists.map((option) => {
    if (option.key != moduleKey) return option
    return {
      ...option,
      active: checked,
      submodules: withToggledSubmodules(option.submodules, checked),
    }
  })

const withVisibilityCheckbox = (opt, isChecked) => ({
  ...opt,
  vCheckBox: isChecked,
  aCheckBox: isChecked ? opt.aCheckBox : false,
  active: isChecked ? opt.aCheckBox : false,
})

const withAccessibilityCheckbox = (opt, isChecked) => ({
  ...opt,
  aCheckBox: isChecked,
  vCheckBox: isChecked ? true : opt.vCheckBox,
  active: isChecked,
})

const updateMatchingSubmodule = (submodules, submoduleKey, isChecked, vCheck) =>
  submodules.map((opt) => {
    if (opt.key != submoduleKey) return opt
    return vCheck ? withVisibilityCheckbox(opt, isChecked) : withAccessibilityCheckbox(opt, isChecked)
  })

export const toggleSubmoduleInOptions = (optionLists, moduleKey, submoduleKey, isChecked, vCheck) =>
  optionLists.map((option) => {
    if (option.key != moduleKey) return option
    return {
      ...option,
      submodules: updateMatchingSubmodule(option.submodules, submoduleKey, isChecked, vCheck),
    }
  })

export const mapSubscriptionTabOptions = (subscriptionSettings, optionTab, getOptionLists, transformOptions) =>
  subscriptionSettings.map((tab) => {
    if (tab.idTab != optionTab) return tab
    return {
      ...tab,
      existingUsers: { optionsList: transformOptions(getOptionLists(tab)) },
    }
  })
